var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"liaan-verticaal",attrs:{"alt":"liana","src":require('../assets/logboek-liaan-verticaal.png')}})
}
var staticRenderFns = []

export { render, staticRenderFns }